import { Component, ViewChild, Input, ElementRef, Inject, EventEmitter, Output} from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { RecSearchService } from '../../rec-search-service';
import { AuthResultVM, RecNameSearchRowVM, RecDocVM, GetRecNameSearchQuery, GetRecNameSearchReportQuery, SearchFilter } from '../../../shared/viewmodels/ISearchService';
//import { forEach } from '@angular/router/src/utils/collection';
import { CompoundNameComponent } from '../../../shared/components/compound-name/compound-name.component'
//import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { Utility } from './../../../shared/viewmodels/UtilityObj';
import { take } from 'rxjs/operators';
import { DatePipe, DecimalPipe } from '@angular/common';
import { State } from '@ngrx/store';
import { Router } from '@angular/router';
import { BrowserModule, DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import Swal from 'sweetalert2';
import {
  DxNumberBoxComponent,
  DxDataGridModule,
  DxNumberBoxModule
} from 'devextreme-angular';
import 'devextreme/data/odata/store';
import { CoreSearchDataState as AppState, getRegSearchState } from '../../../store/reducers/reducers';
import { ReportViewerService } from '../../../shared/services/report-viewer.service';
import CustomStore from 'devextreme/data/custom_store';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { CCPaymentService } from '../../../shared/services/cc-payment-service';
import { GetSBImagesQuery, SBListDTO } from '../../../shared/viewmodels/ISearchService';
import { ShoppingBasketService } from '../../../shared/services/shopping-basket.service';
import { DocBasketComponent } from '../../../shared/components/doc-basket/doc-basket.component';
//import { EventEmitter } from 'events';


@Component({
  selector: 'app-rec-name-search-grid',
  providers: [RecSearchService, ReportViewerService, DatePipe, CCPaymentService, ShoppingBasketService],
  templateUrl: './rec-name-search-grid.component.html',
  styleUrls: ['./rec-name-search-grid.component.css'],
  preserveWhitespaces: true
})
export class RecNameSearchGridComponent {


  @Input() newTab: boolean;
  @Input() lastName: string;
  @Input() firstName: string;
  @Input() roleId: string;
  @Input() parent: any;
  @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
  @ViewChild(CompoundNameComponent, { static: false }) cName: CompoundNameComponent;
  public recsresults: any = {};//RecNameSearchRowVM[];
  public tmprec: RecNameSearchRowVM;
  public recdoc: RecDocVM;
  public re: string;
  applyFilterTypes: any;
  currentFilter: any;
  showFilterRow: boolean;
  console = console;
  towns: string[] = [];
  doctypes: string[] = [];
  lastName2: string;
  firstName2: string;
  roleID2: number;
  public fromDate: Date;
  public toDate: Date;
  public contains: number;
  userInput: any;
  public errorMsg;
  showExportBtn: boolean;
  focusedRowKey: number;
  recordCount: number;
  //@Output() filteredRecordCount = new EventEmitter<number>();
  filteredRecordCount: number; 
  filtersUsed: string;
  criteria: string;
  public remoteOps: any = {};
  public infoFromServer: string;
  appurl: string;
  totalCost: number = 0;
  paymentMethod: string;
  authResp: AuthResultVM;
  showLoader: boolean;
  @ViewChild(DocBasketComponent, { static: false }) docBasketChild;

  constructor(private service: RecSearchService, private reportService: ReportViewerService, private store: Store<AppState>, private router: Router,
    private sanitizer: DomSanitizer, private datepipe: DatePipe, @Inject('BASE_URL') baseUrl: string,
    private ccPmtSvc: CCPaymentService, private auth: AuthenticationService, private SBSvc: ShoppingBasketService) {

    this.remoteOps = {
      paging: false,
      filtering: false,
      sorting: false,
      grouping: false,
      summary: false
    };

    console.log('rec name search grid');
    
    this.store.select(getRegSearchState).pipe(take(1)).subscribe(data => {
      console.log('search data');
      this.userInput = data;
      for (let city of this.userInput.city.citytowns[0].citytowns) {
        if (city.isChecked)
          this.towns.push(city.townAbbrev);
      }

      for (let doctype of this.userInput.doct.doct[0].doctypes) {
        if (doctype.isChecked)
          this.doctypes.push(doctype.docCode);
      }

    });

//    console.log('rec name search role ' + this.userInput.role[0].roleID);

    //this.getResults(
    //  this.userInput.name[0].lastcorpName,
    //  this.userInput.name[0].fName,
    //  this.userInput.date[0].fromDate,
    //  this.userInput.date[0].toDate,
    //  (this.userInput.role[0].roleID == -1) ? 0 : this.userInput.role[0].roleID,
    //  this.towns,
    //  this.doctypes);

    ////Don't open image in another tab'
    ///// Get results from cache.
    //if (localStorage.getItem('recNameSearchResults') === null) {
     //  this.getResults(this.userInput[0].lastcorpName, this.userInput[0].fName, this.userInput[0].fromDate, this.userInput[0].toDate, (this.userInput[0].roleID == -1) ? 0 : this.userInput[0].roleID, this.towns, this.doctypes);
      
   //}
   //else {
    //  this.recsresults = JSON.parse(localStorage.getItem('recNameSearchResults'));
     // this.recordCount = this.recsresults.length;
    
   //}


    this.showFilterRow = true;
    this.applyFilterTypes = [{
      key: "auto",
      name: "Immediately"
    }, {
      key: "onClick",
      name: "On Button Click"
    }];

    this.currentFilter = this.applyFilterTypes[0].key;
    this.appurl = baseUrl;
  }

  mouseover(event) {
    //console.log(`onmouseover fired: ${JSON.stringify(event)}`);
    //console.log(`target: ${event.target.id}`);
    //this.infoFromServer = event.target.id;

    var docIDstring = (event.target.id as string).split('_')[1];
    this.console.log(`Our docId: ${docIDstring}`);
    var docID = Number(docIDstring);
    this.service.getRecDoc(docID).subscribe(data => {
      this.infoFromServer = `
<div style="text-align: left;">
      Grantors: <br />

`;
      data.docTors.forEach(tor => {
        this.infoFromServer += "&nbsp;&nbsp;" + tor.lastCorpName + " " + tor.fName + "<br />";
      });

      this.infoFromServer += "Grantees: <br />";
      data.docTees.forEach(tee => {
        this.infoFromServer += "&nbsp;&nbsp;" + tee.lastCorpName + " " + tee.fName + "<br />"
      });
      this.infoFromServer += "</div>"
    });
  }


  ngOnInit() {

    //console.log('Input ' + this.lastName + ' ' + this.firstName + ' ' + this.roleId);
    //console.log('newtab ' + this.newTab);

    if (localStorage.getItem("machineLocation") == "1") {
      this.showExportBtn = false;
    } else {
      this.showExportBtn = true;
    }

    if (this.lastName > '') {
      //we're open in a new tab
      this.fromDate = new Date('1/1/1962')
      this.toDate = new Date();
      this.contains = 0;
      console.log('Alpha Input ' + this.lastName + ' ' + this.firstName + ' ' + this.roleId + ' ' + this.fromDate + ' ' + this.fromDate + ' ' + this.toDate + ' ' + this.contains + ' ' + this.towns + ' ' + this.doctypes);
      
    }
    else {
      this.lastName = this.userInput.name.name[0].lastcorpName;
      this.firstName = this.userInput.name.name[0].fName;
      this.roleId = this.userInput.role.role[0].roleID;
      this.lastName2 = ''; // this.userInput.name[1].lastcorpName;
      this.firstName2 = ''; //this.userInput.name[1].fName;
      this.roleID2 = 0; //this.userInput.role[1].roleID;

      this.fromDate = this.userInput.date.date[0].fromDate;
      this.toDate = this.userInput.date.date[0].toDate;
      this.contains = this.userInput.contains.contains[0].contains;
      console.log('Rec Name Search Input ' + this.lastName + ' ' + this.firstName + ' ' + this.roleId + ' ' + this.fromDate + ' ' + this.fromDate + ' ' + this.toDate + ' ' + this.contains + ' ' + this.towns + ' ' + this.doctypes);
    }


    this.recsresults = new CustomStore({
      key: "docID",
      load: (loadOptions: any) => {
        let getRecNameSearchQuery = new GetRecNameSearchQuery({
          lastName: this.lastName,
          firstName: this.firstName,
          roleId: +this.roleId,
          lastName2: this.lastName2,
          firstName2: this.firstName2,
          roleId2: this.roleID2,
          fromDate: this.datepipe.transform(this.fromDate, "MM-dd-yyyy"), //this.userInput.date[0].fromDate,
          toDate: this.datepipe.transform(this.toDate, "MM-dd-yyyy"), //this.userInput.date[0].toDate,
          contains: this.contains, 
          towns: this.towns,
          doctypes: this.doctypes
        });
        
        return this.service.getRecNameSearchResults(getRecNameSearchQuery).toPromise().then(data => {
          this.recordCount = data.recNameSearchRows.length;
          this.tmprec = data.recNameSearchRows[0];
          if (data.recNameSearchRows.length > 9999)
            Swal.fire('Max Records Exceeded', 'You have exceeded 10,000 hits.  More results are available.  To access them, narrow your search criteria.')
          return {
            data: data.recNameSearchRows,
            totalCount: data.recNameSearchRows.length
          }
        }).catch(error => { throw error });
      }
    });
    
  }

  getResults(lname, fname, fromdate, todate, roleid, contains, towns, doctypes) {

    let getRecNameSearchQuery = new GetRecNameSearchQuery({
      lastName: lname,
      firstName: fname,
      fromDate: fromdate,
      toDate: todate,
      roleId: roleid,
      contains: contains,
      towns: towns,
      doctypes: doctypes
    });
    console.log(`doctypes: ${doctypes}`);
    console.log(`calling getRecNameSearchResults with ${JSON.stringify(getRecNameSearchQuery)}`);
    console.log(`towns: ${towns}`);

    this.service.getRecNameSearchResults(getRecNameSearchQuery).subscribe(result => {

      console.log('recNameSearchResults');
      console.log(result.recNameSearchRows);
      console.log(Object.keys(result.recNameSearchRows));
      this.recsresults = result.recNameSearchRows;
      this.recordCount = this.recsresults.length;
    });

    //this.service.getResults(lname, fname, fromdate, todate, roleid, towns, doctypes).subscribe(
    //  data => {
    //  this.recsresults = data
    //    this.recordCount = this.recsresults.length;
    //  },
      

    //  ////Don't open image in another tab'
    //  //data => {

    //  //  this.recsresults = data;
    //  //  this.recordCount = this.recsresults.length;
    //  //  for (var _i = 0; _i < this.recsresults.length; _i++) {
    //  //    this.recsresults[_i]["rowId"] = _i;
    //  //  }
    //  //  if (localStorage.getItem('recNameSearchResults')!==null) {
    //  //    localStorage.removeItem('recNameSearchResults');
    //  //  }
    //  //  localStorage.setItem('recNameSearchResults', JSON.stringify(this.recsresults));

    //  //},
    //  error => this.errorMsg = error
    //);
    
  }

  onContentReady(e) {
    this.filteredRecordCount = e.component.totalCount();
//    this.filteredRecordCount.emit();
    console.log('filtered ' + this.filteredRecordCount);
  }

  openImage(e, docID, book, page, cityTown, docType, recordDate, idxPage, idxByPage) {

    console.log('navigate to image ' + idxPage + ' ' + idxByPage);
    let bookNo = 0;

    let loc = localStorage.getItem("machineLocation")

    //plan search
    var cutoffDt = new Date('5/1/2017')
    var tBook = book.substring(0, 2);
    if (docType === "PLAN" && recordDate < cutoffDt && +book < 247 ) {
      const url = this.router.createUrlTree(['rec-plan-name-doc-disp-pg', book, page, 'Recorded'])
      const tUrl = this.appurl + url.toString().substring(1);
      if (loc == '1') {
        var params = [
          'height=' + screen.height,
          'width=' + screen.width,
          'fullscreen=yes' // only works in IE, but here for completeness
        ].join(',');

        var popup = window.open(tUrl, 'popup_window', params);
        popup.moveTo(0, 0);
      } else {
        window.open(tUrl, '_blank');
      }
    }
    else if (book === "TAX" || book === "COL") {
      book = this.service.padLeft(this.service.getCityTaxCode(cityTown, docType, recordDate).toString(), '0', 4);
      //cutoffDt = new Date('1/1/1966');
      //var tp
      //if (this.service.getTypeCat(docType)) {
      //  bookNo = +book + 200;
      //  book = this.service.padLeft(bookNo.toString(), '0', 4);
      //}
      //else if (recordDate < cutoffDt) {
      //  bookNo = +book + 100;
      //  book = this.service.padLeft(bookNo.toString(), '0', 4);
      //}
      page = this.service.padLeft(page, '0', 4);
      const url = this.router.createUrlTree(['/unindexed-doc-disp-pg/', book, page, 29]);
      const tUrl = this.appurl + url.toString().substring(1);
      if (loc == '1') {
        var params = [
          'height=' + screen.height,
          'width=' + screen.width,
          'fullscreen=yes' // only works in IE, but here for completeness
        ].join(',');

        var popup = window.open(tUrl, 'popup_window', params);
        popup.moveTo(0, 0);
      } else {
        window.open(tUrl, '_blank');
      }
    }
    else if (book.substring(0,3) === 'ATT' /*|| book === '0000'*/) {
      let baseBP = '';
      //baseBP = this.service.padLeft(page, '0', 4);
      //book = this.service.padLeft(baseBP.substring(0, 2), '0', 4);
      //page = baseBP.substring(2) + '01';
      const url = this.router.createUrlTree(['/unindexed-doc-disp-pg/', book, page, 30]);
      const tUrl = this.appurl + url.toString().substring(1);
      if (loc == '1') {
        var params = [
          'height=' + screen.height,
          'width=' + screen.width,
          'fullscreen=yes' // only works in IE, but here for completeness
        ].join(',');

        var popup = window.open(tUrl, 'popup_window', params);
        popup.moveTo(0, 0);
      } else {
        window.open(tUrl, '_blank');
      }

    }
    else if (book === 'FILE') {
      //Old Federal Tax Liens

      //let baseBP = '';
      //baseBP = this.service.padLeft(page, '0', 4);
      //book = this.service.padLeft(baseBP.substring(0, 2), '0', 4);
      //page = baseBP.substring(2) + '01';
      const url = this.router.createUrlTree(['/unindexed-doc-disp-pg/', book, page, 28]);
      const tUrl = this.appurl + url.toString().substring(1);
      if (loc == '1') {
        var params = [
          'height=' + screen.height,
          'width=' + screen.width,
          'fullscreen=yes' // only works in IE, but here for completeness
        ].join(',');

        var popup = window.open(tUrl, 'popup_window', params);
        popup.moveTo(0, 0);
      } else {
        window.open(tUrl, '_blank');
      }

    }
    else if (book === 'OAAL') {

      const url = this.router.createUrlTree(['/unindexed-doc-disp-pg/', book, page, 31]);
      const tUrl = this.appurl + url.toString().substring(1);
      if (loc == '1') {
        var params = [
          'height=' + screen.height,
          'width=' + screen.width,
          'fullscreen=yes' // only works in IE, but here for completeness
        ].join(',');

        var popup = window.open(tUrl, 'popup_window', params);
        popup.moveTo(0, 0);
      } else {
        window.open(tUrl, '_blank');
      }

    }
    else {
      //the rest of the docs
      console.log('idx page ' + idxPage + ' ' + idxByPage);
      //if doc type not allowed to scroll by page, set back to first page
      if (idxByPage === 0)
        idxPage = 0;

      if (book === "0000") {
        book = 'AX' + book;
      }

      const url = this.router.createUrlTree(['/rec-address-doc-disp-pg', docID, book, page, idxPage]);
      const tUrl = this.appurl + url.toString().substring(1);
      if (loc == '1') {
        var params = [
          'height=' + screen.height,
          'width=' + screen.width,
          'fullscreen=yes' // only works in IE, but here for completeness
        ].join(',');

        var popup = window.open(tUrl, 'popup_window', params);
        popup.moveTo(0, 0);
      } else {
        window.open(tUrl, '_blank');
      }
    }
  }

  getRecDoc(docId: number) {
    this.service.getRecDoc(docId).subscribe(
      data => { this.recdoc = data },
            error => { this.errorMsg = error }
    );
  }



  clearFilter() {
    this.dataGrid.instance.clearFilter();
  }

  onInitialized(e) {

  }

  //Open image in another tab'
  imgClicked(event) {
    if (!this.dataGrid.instance.isRowSelected(event.row.key)) {
      this.dataGrid.instance.selectRows(event.row.key, false);
    }
   // this.nav.visible = false;


  }

  onExpanding(e) {
    this.focusedRowKey = e.component.option("focusedRowIndex");
    this.focusedRowKey = e.key.index;
    e.component.collapseAll(-1);
  }

  //onRowClickEvent(e) {
  //  var component = e.component;

  //  function initialClick() {
  //    console.log('initial click for key ' + e.key);
  //    component.clickCount = 1;
  //    component.clickKey = e.key;
  //    component.clickDate = new Date();
  //  }

  //  function doubleClick() {
  //    console.log('second click');
  //   // this.router.navigate(['/rec-doc-detail-parent', e.data.docID, e.data.recLandBook, e.data.recLandPage]);
  //    component.clickCount = 0;
  //    component.clickKey = 0;
  //    component.clickDate = null;
  //  }

  //  if ((!component.clickCount) || (component.clickCount != 1) || (component.clickKey != e.key)) {
  //    initialClick();
  //  }
  //  else if (component.clickKey == e.key) {
  //    if (((new Date()).getDate() - component.clickDate) <= 300) {
  //      doubleClick();
  //      this.router.navigate(['/rec-doc-detail-parent', e.data.docID, e.data.recLandBook, e.data.recLandPage]);
  //     // this.focusedRowKey = e.data.docID;
  //      this.focusedRowKey = e.component.option("focusedRowKey");
  //      this.onFocusedRowChanged(e);
  //    }
  //    else
  //      initialClick();
  //  }
  //     // this.router.navigate(['/rec-doc-detail-parent', e.data.docID, e.data.recLandBook, e.data.recLandPage]);


  //  this.focusedRowKey = e.component.option("focusedRowKey");



  //}

  //onFocusedRowChanging(e) {
  //  this.focusedRowKey = e.component.option("focusedRowIndex");
  //}

  //onFocusedRowChanged(e) {
  //  this.focusedRowKey = e.component.option("focusedRowIndex");
  //}



  //Don't Open image in another tab'
  //ShowImageDetail(e) {
  //  try {
  //    this.focusedRowKey = e.component.option("focusedRowIndex");
  //    localStorage.removeItem('rowKey')
  //    localStorage.setItem('rowKey', this.focusedRowKey.toString());
  //    if (e.component.option("focusedColumnIndex") == 8) {
  //      this.router.navigate(['/rec-doc-detail-parent', e.data.docID, e.data.recLandBook, e.data.recLandPage]);
  //    }
  //  }
  //  catch (error) {
  //    this.service.logError(error);
  //  }
  //}



  //onContentReady(e) {
  //  try {
  //    if (typeof (Storage) !== "undefined") {
  //      this.focusedRowKey = Number(localStorage.getItem('rowKey'));
  //    }
  //    e.component.focus(e.component.getRowElement(this.focusedRowKey));
  //  }
  //  catch (error) {
  //    this.service.logError(error);
  //  }
  //}

  assignTypes(filters: SearchFilter[]) {
    if (filters) {
      filters.forEach(fl => {
        if (fl.filterType == 'join') {
          this.assignTypes(fl.filters);
        } else {
          //for (var prop in this.recsresults[0]) {
          //  if (prop == fl.fieldName) {
          //    fl.fieldType = typeof this.recsresults[0][prop];
          //  }
          //}
          for (var prop in this.tmprec) {
            if (prop == fl.fieldName) {
              fl.fieldType = typeof this.tmprec[prop];
            }
          }
        }

      });
    }
  }


  async export() {
    //Swal.fire("Export of search results is coming soon!")
    //return;

    //Swal.fire(this.filteredRecordCount.toString())
    //return;
    //console.log('filtered ' + this.filteredRecordCount);

    this.filtersUsed = this.dataGrid.instance.getCombinedFilter(true);// [["firstGrantor", "contains", "bed"], "and", ["firstGrantee", "contains", "or"], "and", ["recLandBook", "contains", "3"]];//[[["recordDate", "<", "2000-04-03T04:00:00.000Z"], "or", ["recordDate", ">=", "2000-04-04T04:00:00.000Z"]], "and", ["firstGrantor", "contains", "BED"]];//
    console.log("role " + this.roleId);
    var role = "";
    if (this.roleId == "1")
      role = "Grantor";
    if (this.roleId == "2")
      role = "Grantee";
    if (this.roleId == "0")
      role = "Both";

    var docType = this.doctypes.toString();
    if (docType == '')
    docType = "All Types";

    var towns = this.towns.toString();
    if (towns == '')
    towns = "All Towns";

    this.criteria = "Criteria - " + this.lastName + " " + this.firstName + " " + role + " " + this.fromDate + " - " + this.datepipe.transform(this.toDate, "MM-dd-yyyy") + " " + towns + " " + docType;

    if (localStorage.getItem("machineLocation") == "0")
      await this.getPaymentMethod();
    else if(localStorage.getItem("machineLocation") == "2") 
      this.openExport();

  }

  openExport() {

    var filterExpression = this.filtersUsed ? JSON.stringify(this.filtersUsed) : "";
    console.log('filtersUsed - ' + this.filtersUsed);
    console.log(`filterExpression: ${filterExpression}`);
    var filterObjs = new Array<SearchFilter>();
    if (filterExpression) {
      var filtersOnGrid = SearchFilter.subHelper(this.filtersUsed, 0);
      filterObjs = [...filtersOnGrid];
      this.assignTypes(filterObjs);
      console.log(`filterObjs: ${JSON.stringify(filterObjs)}`);
      //filtersOnGrid.forEach(f => filters.push(JSON.stringify(f)));
      //console.log(`filters: ${JSON.stringify(filters)}`);
    }

    //this.console.log('Inside Export');
    //var t = this.userInput.name.name[0].lastcorpName;
    //console.log(t);
    let getRecNameSearchReportQuery = new GetRecNameSearchReportQuery({
      lastName: this.userInput.name.name[0].lastcorpName,
      firstName: this.userInput.name.name[0].fName,
      fromDate: this.userInput.date.date[0].fromDate,
      toDate: this.userInput.date.date[0].toDate,
      roleId: (this.userInput.role.role[0].roleID == -1) ? 0 : this.userInput.role.role[0].roleID,
      towns: this.towns,
      doctypes: this.doctypes,
      sortBy: new Array<string>(),
      sortDirection: "desc",
      filterExpression: filterExpression,
      filterObjects: filterObjs
    });
    this.console.log(this.userInput.date.date[0].fromDate);
    this.console.log(getRecNameSearchReportQuery.toJSON());
    this.reportService.getRecNameSearchReport(getRecNameSearchReportQuery).subscribe((reportName) => {
      //this.reportUrl = reportName.reportName;
      this.console.log(`rerportName: ${reportName.reportName}`);
      this.router.navigate([`/report-viewer/${reportName.reportName}`]);
    });

  }

  async getPaymentMethod() {

    //console.log('export mthd');
    this.totalCost = this.service.setExportCost(this.filteredRecordCount);
    let cost = parseFloat(this.totalCost.toString()).toFixed(2);
    let today = this.datepipe.transform(Date.now(), 'MM-dd-yyyy');
    let time = this.datepipe.transform(Date.now(), 'hh:mm a');

    let x = await Swal.fire({
      title: 'Select Payment Method',
      showCancelButton: true,
      allowEnterKey: true,
      html:
        '<br>' +
        'Total Cost for this Export is $' + cost + '<br><br>' +
        'Payment Method<br>' +
        '<input type="radio" id="radio1" name="paymentMethod" style="display: inline-block; text-align: left;" value="1"> Account&nbsp;&nbsp;&nbsp;<input type="radio" id="radio2" name="paymentMethod" style="display: inline-block; text-align: left;" value="2"> Credit Card' +
        '<br><br>*** This export of index data is from a living index database as of the moment ordered and is subject to any corrections of the official record made by the Registry of Deeds.  This export was ordered on ' + today + ' at ' + time
    }).then((result) => {
      this.paymentMethod = $('input[name=paymentMethod]:checked').val().toString();

      if (result.dismiss === undefined) {
        console.log('pmt ' + this.paymentMethod + ' cost ' + this.totalCost);
        if (this.paymentMethod === "1")
          //account payment
          this.checkAccount();
        else if (this.paymentMethod === '2') {
          //credit card processing
          this.processCC();
        }
        else {
          //nothing selected
        }
      }
      else {
        console.log('no dice');
        return;
      }
    });
  }

  async checkAccount() {

//    let userName = localStorage.getItem('uid');
//    let guid = localStorage.getItem('guid');

    await this.auth.ValidateGuid();
    console.log(this.auth.guid + ' ' + this.auth.success);
    if (this.auth.success === 0) {
      //not valid, so get login
      await this.auth.getCredentials();
      console.log('auth ' + this.auth.success)
      if (this.auth.success === 0)
        //login unsuccessful - abort
        return;
    }
    if (this.auth.success === 1) {
      //check if money is ok

      const regExp = /,/g;
      let filterString = '';
      if (this.filtersUsed) {
        filterString = this.filtersUsed.toString();
        filterString = filterString.replace(regExp, ' ');
      }
      let sbQuery = new GetSBImagesQuery({
        emailList: false,
        emailAddress: '',
        zipList: false,
        //sBList: sblist,
        credentialGUID: this.auth.guid,
        submissionType: 0,   //this.machineType,
        internalUserID: this.auth.uid,
        internalDescription: 'export',
        optionalPhone: '',
        optionalZipCode: '',
        totalFee: this.totalCost,
        units: this.filteredRecordCount,
        filter: this.criteria + " - Filter - " + filterString
      });

      await this.SBSvc.getSBAuth(sbQuery).toPromise()
        .then(data => {
          this.authResp = data.body;
          //console.log('msg - ' + this.authResp.msg);
          //console.log('keys ' + Object.keys(data.body));
        });

      //(error => { this.error = error }),
      //(() => { console.log('authResp  - '+ this.authResp.success); });

      console.log('post getSBAuth ' + this.authResp.success);

      if (this.authResp.success === 0) {
        Swal.fire('Authorization Failed', this.authResp.msg);
        return;
      }
      else {
        //write data to atransaction for account trans
        await this.SBSvc.saveSBCharge(sbQuery).toPromise()
          .then(data => {
            this.SBSvc.logServiceError('export saveSBCharge - ' + data.body)
          },
            error => {
              //logging here
              //this.error = error;
              this.SBSvc.logServiceError('export saveSBCharge Error - ' + Object.keys(error) + ' ' + error.headers + ' ' + error.name + ' ' + error.message + ' ' + Object.keys(error.error) + ' ' +  '  - ' + window.navigator.appName + ' ' + window.navigator.appVersion + ' ' + window.navigator.platform);
            }
         );

        //all good - open the export window
        this.openExport();
      }
    }
  }

  async processCC() {
    console.log('export processCC');
    this.ccPmtSvc.totAmount = this.totalCost;

    await this.ccPmtSvc.getCreditCardInfo();

    
    if (this.ccPmtSvc.infoEntered = 1) {

      this.showLoader = true;
      await this.ccPmtSvc.authorizeCard();

      if (this.ccPmtSvc.ccPmt.authCode != '') {
        //success

        let regExp = /,/g;
        let filterString = '';
        if (this.filtersUsed) {
          filterString = this.filtersUsed.toString();
          filterString = filterString.replace(regExp, ' ');
        }
        let sbQuery = new GetSBImagesQuery({
          emailList: false,
          emailAddress: '',
          zipList: false,
          //sBList: sblist,
          credentialGUID: '',  //this.auth.guid,
          submissionType: 0,   //this.machineType,
          internalUserID: '',  //this.auth.uid,
          internalDescription: 'export',
          optionalPhone: '',
          optionalZipCode: '',
          authCode: this.ccPmtSvc.ccPmt.authCode,
          orderId: this.ccPmtSvc.ccPmt.orderId,
          totalFee: this.totalCost,
          units: this.filteredRecordCount,
          filter: this.criteria + " - Filter - " + filterString
        });

        //write data to atransaction 
        await this.ccPmtSvc.completeSBChargeandCCSale(sbQuery).toPromise()
          .then(data => {
            this.SBSvc.logServiceError('export cc saveSBCharge - ' + data.body)
            if (data.body === true) {
              this.ccPmtSvc.resetCCPmt();
              this.showLoader = false;
              this.openExport();
            }
          },
            error => {
              //logging here
              //this.error = error;
              this.SBSvc.logServiceError('export cc saveSBCharge Error - ' + Object.keys(error) + ' ' + error.headers + ' ' + error.name + ' ' + error.message + ' ' + Object.keys(error.error) + ' ' + '  - ' + window.navigator.appName + ' ' + window.navigator.appVersion + ' ' + window.navigator.platform);
            }
          );
      }
    }
    this.showLoader = false;
  }


}
